export enum RatingScalePresentation {
  Thumbs4 = 'thumbs_4',
  Thumbs5 = 'thumbs_5',
  Stars = 'stars',
  Hearts = 'hearts',
  Smileys = 'smileys',
  Numeric = 'numeric',
}

export enum RatingScaleScoreDisplay {
  Percentage = 'percentage',
  Average = 'average',
}

export interface RatingScalePoint {
  score: number;
  label: string | null;
}

export interface RatingScale {
  range: number;
  presentation: RatingScalePresentation;
  scoreDisplay: RatingScaleScoreDisplay;
  points: RatingScalePoint[];
}
